import React, { useState, useEffect } from 'react';
import './Voting.css';

const Voting = () => {
  const [currentVoteId, setCurrentVoteId] = useState('');
  const [voteResults, setVoteResults] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(new Map());
  const [playerVotes, setPlayerVotes] = useState(new Set());
  const [gamePhase, setGamePhase] = useState('input-id'); // input-id, select-seat, voting, results
  const [currentVoterId, setCurrentVoterId] = useState(''); // 当前投票者ID
  const [selectedSeat, setSelectedSeat] = useState(null); // 选择的座位
  const [tempSelectedSeat, setTempSelectedSeat] = useState(null); // 临时选择的座位

  // 桌椅布局配置：双数列4人，单数列5人，所有列放同一排
  const seatLayout = [
    { column: 1, seats: 5, startNumber: 1 },    // 第1列：1-5号（单数列5人）
    { column: 2, seats: 4, startNumber: 6 },    // 第2列：6-9号（双数列4人）
    { column: 3, seats: 5, startNumber: 10 },   // 第3列：10-14号（单数列5人）
    { column: 4, seats: 4, startNumber: 15 },   // 第4列：15-18号（双数列4人）
    { column: 5, seats: 5, startNumber: 19 },   // 第5列：19-23号（单数列5人）
    { column: 6, seats: 4, startNumber: 24 }    // 第6列：24-27号（双数列4人）
  ];

  // 生成座位数组
  const generateSeats = () => {
    const seats = [];
    seatLayout.forEach((col) => {
      for (let i = 0; i < col.seats; i++) {
        const seatNumber = col.startNumber + i;
        seats.push({
          id: seatNumber,
          column: col.column,
          row: i + 1,
          avatarId: `avatar_${seatNumber}`,
          avatarNumber: seatNumber,
          status: 'active' // 'active', 'selected', 'voted'
        });
      }
    });
    return seats;
  };

  const [seats, setSeats] = useState(generateSeats());

  // 生成唯一的投票者ID
  const generateVoterId = () => {
    return `voter_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  };

  // 输入投票ID并开始投票
  const startVoting = async () => {
    if (!currentVoteId.trim()) {
      setMessage('请输入投票ID！');
      return;
    }

    if (pendingRequests.has('start-voting')) {
      setMessage('请求正在进行中，请稍候...');
      return;
    }

    setLoading(true);
    setPendingRequests(prev => new Map(prev).set('start-voting', true));
    
    try {
      // 生成新的投票者ID
      const voterId = generateVoterId();
      setCurrentVoterId(voterId);
      
      // 创建或进入投票轮次
      const response = await fetch('http://localhost:3001/api/voting/create-game', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          routeId: currentVoteId.trim(),
          avatarCount: 27
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        if (data.existing) {
          setMessage(`进入现有游戏 ${currentVoteId}！请选择你的座位`);
        } else {
          setMessage(`新游戏 ${currentVoteId} 创建成功！请选择你的座位`);
        }
        setGamePhase('select-seat');
        setPlayerVotes(new Set());
        setSelectedSeat(null);
        setTempSelectedSeat(null);
        await fetchAvailableSeats(); // 获取可选择的座位
      } else {
        setMessage(data.error || '开始投票失败');
      }
    } catch (error) {
      setMessage('开始投票时出错: ' + error.message);
    } finally {
      setLoading(false);
      setPendingRequests(prev => {
        const newMap = new Map(prev);
        newMap.delete('start-voting');
        return newMap;
      });
    }
  };

  // 获取可选择的座位
  const fetchAvailableSeats = async () => {
    if (!currentVoteId.trim()) return;
    
    try {
      const response = await fetch(`http://localhost:3001/api/voting/available-seats/${currentVoteId.trim()}`);
      const data = await response.json();
      
      if (response.ok) {
        // 更新座位状态
        setSeats(prevSeats => 
          prevSeats.map(seat => {
            const availableSeat = data.find(s => s.avatar_id === seat.avatarId);
            return {
              ...seat,
              status: availableSeat?.status || 'active'
            };
          })
        );
      }
    } catch (error) {
      console.error('获取可选择座位失败:', error);
    }
  };

  // 临时选择座位
  const tempSelectSeat = (seatNumber) => {
    const seat = seats.find(s => s.id === seatNumber);
    
    if (seat.status !== 'active') {
      setMessage('该座位已被选择，请选择其他座位');
      return;
    }
    
    setTempSelectedSeat(seatNumber);
    setMessage(`你选择了座位 ${seatNumber}，请点击确认按钮确认选择`);
  };

  // 确认选择座位
  const confirmSeatSelection = async () => {
    if (!tempSelectedSeat) return;
    
    if (pendingRequests.has('confirm-seat')) {
      setMessage('请求正在进行中，请稍候...');
      return;
    }

    setPendingRequests(prev => new Map(prev).set('confirm-seat', true));
    
    try {
      const response = await fetch('http://localhost:3001/api/voting/select-seat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          routeId: currentVoteId.trim(),
          avatarId: `avatar_${tempSelectedSeat}`,
          voterId: currentVoterId
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        setSelectedSeat(tempSelectedSeat);
        setGamePhase('voting');
        setMessage(`你确认选择了座位 ${tempSelectedSeat}，现在可以开始投票了！每人需要投5票，不能投给自己`);
        
        // 更新座位状态
        setSeats(prevSeats => 
          prevSeats.map(seat => 
            seat.id === tempSelectedSeat 
              ? { ...seat, status: 'selected' }
              : seat
          )
        );
      } else if (response.status === 400) {
        setMessage('这个座位已经投过票了');
      } else {
        setMessage(data.error || '确认座位失败');
      }
    } catch (error) {
      setMessage('确认座位时出错: ' + error.message);
    } finally {
      setPendingRequests(prev => {
        const newMap = new Map(prev);
        newMap.delete('confirm-seat');
        return newMap;
      });
    }
  };

  // 临时投票（不立即提交到数据库）
  const tempVoteForPlayer = (avatarId) => {
    if (!selectedSeat) return;
    
    // 不能投给自己
    if (avatarId === `avatar_${selectedSeat}`) {
      setMessage('不能投给自己！请选择其他玩家');
      return;
    }
    
    if (playerVotes.size >= 5) {
      setMessage('你已经投了5票，无法继续投票');
      return;
    }
    
    if (playerVotes.has(avatarId)) {
      setMessage('你已经给这个玩家投过票了，每人最多投一票');
      return;
    }
    
    // 添加到临时投票集合
    setPlayerVotes(prev => new Set(prev).add(avatarId));
    setMessage(`临时投票成功！你已经投了 ${playerVotes.size + 1}/5 票`);
  };

  // 取消临时投票
  const cancelTempVote = (avatarId) => {
    setPlayerVotes(prev => {
      const newSet = new Set(prev);
      newSet.delete(avatarId);
      return newSet;
    });
    setMessage(`投票取消成功！你已经投了 ${playerVotes.size - 1}/5 票`);
  };

  // 确认所有投票（批量提交到数据库）
  const confirmAllVotes = async () => {
    if (playerVotes.size !== 5) {
      setMessage('请确保投满5票后再确认！');
      return;
    }

    if (pendingRequests.has('confirm-votes')) {
      setMessage('请求正在进行中，请稍候...');
      return;
    }

    setPendingRequests(prev => new Map(prev).set('confirm-votes', true));
    
    try {
      // 批量提交所有投票
      const votePromises = Array.from(playerVotes).map(avatarId => 
        fetch('http://localhost:3001/api/voting/vote', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            routeId: currentVoteId.trim(),
            avatarId: avatarId,
            voterId: currentVoterId,
            roundNumber: 1
          })
        })
      );

      const responses = await Promise.all(votePromises);
      const results = await Promise.all(responses.map(r => r.json()));
      
      // 检查是否所有投票都成功
      const allSuccess = results.every(r => r.success);
      
      if (allSuccess) {
        setMessage('恭喜！所有投票已确认提交，现在可以查看投票结果了');
        setGamePhase('results');
        await fetchVoteResults(); // 显示最终结果
        
        // 更新座位状态为已投票
        setSeats(prevSeats => 
          prevSeats.map(seat => 
            playerVotes.has(seat.avatarId)
              ? { ...seat, status: 'voted' }
              : seat
          )
        );
      } else {
        setMessage('部分投票提交失败，请重试');
      }
    } catch (error) {
      setMessage('确认投票时出错: ' + error.message);
    } finally {
      setPendingRequests(prev => {
        const newMap = new Map(prev);
        newMap.delete('confirm-votes');
        return newMap;
      });
    }
  };

  // 获取投票结果
  const fetchVoteResults = async () => {
    if (!currentVoteId.trim()) return;
    
    try {
      const response = await fetch(`http://localhost:3001/api/voting/vote-results/${currentVoteId.trim()}/1`);
      const data = await response.json();
      
      if (response.ok) {
        setVoteResults(data);
      }
    } catch (error) {
      console.error('获取投票结果失败:', error);
    }
  };

  // 开始新的投票
  const startNewVoting = () => {
    setCurrentVoteId('');
    setCurrentVoterId('');
    setSelectedSeat(null);
    setTempSelectedSeat(null);
    setPlayerVotes(new Set());
    setVoteResults([]);
    setMessage('');
    setGamePhase('input-id');
    
    // 重置座位状态
    setSeats(generateSeats());
  };

  // 渲染输入投票ID界面
  const renderInputId = () => {
    return (
      <div className="input-vote-id">
        <h3>🎯 投票助手</h3>
        <p className="description">
          请输入投票轮次ID，然后选择座位并投出你的5票
        </p>
        
        <div className="input-group">
          <label>投票轮次ID:</label>
          <input
            type="text"
            value={currentVoteId}
            onChange={(e) => setCurrentVoteId(e.target.value)}
            placeholder="输入投票轮次ID (如: round001)"
            className="vote-id-input"
          />
        </div>
        
        <button 
          onClick={startVoting} 
          disabled={loading || pendingRequests.has('start-voting')}
          className="btn start-voting-btn"
        >
          {loading ? '开始中...' : '开始投票'}
        </button>
      </div>
    );
  };

  // 渲染选择座位界面
  const renderSelectSeat = () => {
    return (
      <div className="select-seat-interface">
        <div className="seat-selection-header">
          <h3>🪑 选择你的座位</h3>
          <p>投票轮次: {currentVoteId}</p>
          <p>请根据实际座位布局选择你的座位号</p>
          <p className="layout-info">布局说明：单数列（1、3、5列）5人，双数列（2、4、6列）4人</p>
        </div>
        
        <div className="seat-layout-single-row">
          {seatLayout.map((col) => (
            <div key={col.column} className="seat-column">
              <div className="column-label">第{col.column}列</div>
              <div className="column-seats">
                {seats
                  .filter(seat => seat.column === col.column)
                  .map(seat => (
                    <div 
                      key={seat.id}
                      className={`seat-item selectable ${tempSelectedSeat === seat.id ? 'temp-selected' : ''} ${seat.status !== 'active' ? 'unavailable' : ''}`}
                      onClick={() => seat.status === 'active' && tempSelectSeat(seat.id)}
                    >
                      <div className="seat-number">{seat.avatarNumber}</div>
                      <div className="seat-status">
                        {seat.status === 'active' ? '点击选择' : 
                         seat.status === 'selected' ? '已选择' : '已投票'}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>

        <div className="seat-selection-controls">
          {tempSelectedSeat && (
            <button 
              onClick={confirmSeatSelection}
              disabled={pendingRequests.has('confirm-seat')}
              className="btn confirm-seat-btn"
            >
              {pendingRequests.has('confirm-seat') ? '确认中...' : `确认选择座位 ${tempSelectedSeat}`}
            </button>
          )}
          
          <button 
            onClick={() => setGamePhase('input-id')}
            className="btn back-btn"
          >
            返回
          </button>
        </div>
      </div>
    );
  };

  // 渲染投票界面
  const renderVotingInterface = () => {
    return (
      <div className="voting-interface">
        <div className="vote-header">
          <h3>🗳️ 投票进行中</h3>
          <p>投票轮次: {currentVoteId}</p>
          <p>你的座位: {selectedSeat}号</p>
          <div className="vote-progress">
            <span className="progress-label">投票进度:</span>
            <span className="progress-bar">
              <span 
                className="progress-fill" 
                style={{ width: `${(playerVotes.size / 5) * 100}%` }}
              ></span>
            </span>
            <span className="progress-text">{playerVotes.size}/5 票</span>
          </div>
        </div>
        
        <div className="voting-grid">
          <h4>按照桌椅布局点击头像进行投票 (每人投5票，每人最多投一票，不能投给自己)</h4>
          <p className="voting-note">💡 点击投票按钮进行临时投票，投满5票后点击"确认投票"按钮提交</p>
          
          {/* 桌椅布局 - 所有列放同一排 */}
          <div className="seat-layout-single-row">
            {seatLayout.map((col) => (
              <div key={col.column} className="seat-column">
                <div className="column-label">第{col.column}列</div>
                <div className="column-seats">
                  {seats
                    .filter(seat => seat.column === col.column)
                    .map(seat => {
                      const hasVoted = playerVotes.has(seat.avatarId);
                      const isMySeat = seat.id === selectedSeat;
                      
                      return (
                        <div 
                          key={seat.id}
                          className={`seat-item ${hasVoted ? 'voted' : ''} ${isMySeat ? 'my-seat' : ''}`}
                        >
                          <div className="seat-number">{seat.avatarNumber}</div>
                          
                          {isMySeat ? (
                            <div className="my-seat-label">我的座位</div>
                          ) : hasVoted ? (
                            <div className="vote-actions">
                              <div className="voted-label">已投票</div>
                              <button 
                                className="cancel-vote-btn"
                                onClick={() => cancelTempVote(seat.avatarId)}
                              >
                                取消
                              </button>
                            </div>
                          ) : (
                            <button 
                              className="vote-btn"
                              onClick={() => tempVoteForPlayer(seat.avatarId)}
                              disabled={playerVotes.size >= 5}
                            >
                              投票
                            </button>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="voting-controls">
          <button 
            onClick={confirmAllVotes}
            disabled={playerVotes.size !== 5 || pendingRequests.has('confirm-votes')}
            className="btn confirm-votes-btn"
          >
            {pendingRequests.has('confirm-votes') ? '确认中...' : '确认投票'}
          </button>
        </div>
      </div>
    );
  };

  // 渲染投票结果界面
  const renderResults = () => {
    return (
      <div className="results-interface">
        <div className="results-header">
          <h3>📊 投票结果</h3>
          <p>投票轮次: {currentVoteId}</p>
          <p>你的座位: {selectedSeat}号</p>
        </div>
        
        <div className="results-grid">
          <h4>投票排名</h4>
          <div className="results-list">
            {voteResults.map((player, index) => (
              <div key={player.avatar_id} className={`result-item ${index < 3 ? 'top3' : ''}`}>
                <span className="rank">#{index + 1}</span>
                <span className="player">玩家 {player.avatar_number}</span>
                <span className="votes">{player.vote_count} 票</span>
                {index < 3 && <span className="top3-badge">前3名</span>}
              </div>
            ))}
          </div>
        </div>

        <div className="results-controls">
          <button 
            onClick={startNewVoting}
            className="btn new-voting-btn"
          >
            开始新投票
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="voting">
      <h2>🗳️ 投票助手</h2>
      
      {/* 请求状态指示器 */}
      {pendingRequests.size > 0 && (
        <div className="request-status active">
          处理中... ({pendingRequests.size} 个请求)
        </div>
      )}
      
      {message && (
        <div className="message">
          {message}
        </div>
      )}

      {gamePhase === 'input-id' && renderInputId()}
      {gamePhase === 'select-seat' && renderSelectSeat()}
      {gamePhase === 'voting' && renderVotingInterface()}
      {gamePhase === 'results' && renderResults()}
    </div>
  );
};

export default Voting;
